import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SuratJalan.css";
import usePrintRaceStore from "../zustand/Store/untukPrint/PrintRace";
import { Col, Row } from "react-bootstrap";
import { Col as AntCol, Row as AntRow } from "antd";
import JsBarcode from "jsbarcode-fixed";
import { printAfterRender } from "../util/printAfterRender";
import moment from "moment";

const getPrintAddress = (item) => {
  const spNumber = item?.sp || item?.so || item?.sm || "";
  const isRoSp = typeof spNumber === "string" && spNumber.startsWith("21-RO-");

  if (isRoSp) {
    return (
      item?.idAlmuat?.alamat ||
      item?.detail?.[0]?.idAlmuat?.alamat ||
      item?.alamatMuat?.alamat ||
      item?.detail?.[0]?.alamatMuat?.alamat ||
      item?.detail?.[0]?.alamatSekolah ||
      item?.alamatBongkar ||
      item?.alamat ||
      "-"
    );
  }

  return item?.detail?.[0]?.alamatSekolah || item?.alamatBongkar || item?.alamat || "-";
};

const hasValue = (value) =>
  value !== undefined && value !== null && `${value}`.trim() !== "" && value !== "-";

const pickValue = (...values) => {
  const value = values.find(hasValue);
  return value === undefined ? "-" : value;
};

const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const getSchoolName = (detailItem, parentItem = {}) =>
  pickValue(
    detailItem?.sekolahTujuan,
    detailItem?.sekolahtujuan,
    detailItem?.sekolah,
    detailItem?.nama_sekolah,
    detailItem?.penerima,
    detailItem?.pic,
    detailItem?.alamatMuat?.pic,
    detailItem?.idAlmuat?.pic,
    parentItem?.sekolahTujuan,
    parentItem?.sekolahtujuan,
    parentItem?.sekolah,
    parentItem?.nama_sekolah,
    parentItem?.penerima,
    parentItem?.pic
  );

const getMemoText = (detailItem, parentItem = {}) =>
  pickValue(
    detailItem?.SjErlangga,
    parentItem?.SjErlangga,
    detailItem?.memo,
    parentItem?.memo,
    detailItem?.sm,
    parentItem?.sm,
    parentItem?.so,
    parentItem?.sp
  );

const getPrintRows = (item) => {
  const detail = Array.isArray(item?.detail) && item.detail.length > 0 ? item.detail : [item];

  return detail.map((detailItem) => ({
    ...detailItem,
    sekolahTujuan: getSchoolName(detailItem, item),
    memoText: getMemoText(detailItem, item),
    koli: toNumber(pickValue(detailItem?.koli, item?.koli, 0)),
    ikat: toNumber(pickValue(detailItem?.ikat, item?.ikat, 0)),
  }));
};

const PrintRO1Halaman = () => {
  const setDetailSJRace = usePrintRaceStore((state) => state.setDetailSJRace);
  const DetailSJRace = usePrintRaceStore((state) => state.DetailSJRace);
  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    const dataString = localStorage.getItem("printDataRO");
    console.log("Data from localStorage:", dataString);
    if (dataString) {
      try {
        const data = JSON.parse(dataString);
        console.log("Parsed data:", data);
        // Ensure data is an array
        const dataArray = Array.isArray(data) ? data : [data];
        console.log("Data array:", dataArray);
        setDetailSJRace(dataArray);
        setLocalData(dataArray); // Also set local state
      } catch (error) {
        console.error("Error parsing data:", error);
      }
    } else {
      console.warn("No data found in localStorage");
    }
  }, [setDetailSJRace]);

  useEffect(() => {
    console.log("DetailSJRace state:", DetailSJRace);
    console.log("LocalData state:", localData);
    
    // Use localData or DetailSJRace, whichever is available
    const displayData = localData.length > 0 ? localData : (Array.isArray(DetailSJRace) && DetailSJRace.length > 0 ? DetailSJRace : []);
    
    console.log("DisplayData:", displayData);
    console.log("Is array?", Array.isArray(displayData));
    console.log("Length:", displayData.length);
    
    if (displayData.length > 0) {
      displayData.forEach((item, index) => {
        JsBarcode(`#barcode${index}`, item.sp || item.so || item.sm || item.idMp || "-", {
          format: "CODE128",
          lineColor: "#000000",
          width: 1.9,
          height: 50,
          displayValue: true,
        });
      });
      // window.print() ditunda ke luar fase commit React, setelah barcode tergambar
      return printAfterRender();
    }
    return undefined;
  }, [DetailSJRace, localData]);

  const date = new Date();
  const hariini = moment(date).format("YYYY-MM-DD");

  useEffect(() => {
    document.title = `SJRCPrint_All_${hariini}_1hal`;
  }, [hariini]);

  // Use localData or DetailSJRace, whichever is available
  const displayData = localData.length > 0 ? localData : (Array.isArray(DetailSJRace) && DetailSJRace.length > 0 ? DetailSJRace : []);

  console.log("Render - DetailSJRace:", DetailSJRace);
  console.log("Render - LocalData:", localData);
  console.log("Render - DisplayData:", displayData);
  console.log("Render - Is array?", Array.isArray(displayData));
  console.log("Render - Length:", displayData.length);

  return (
    <div className="print-one-body" style={{ backgroundColor: "white" }}>
      {displayData.length > 0 ? (
        displayData.map((item, index) => {
          const detailRows = getPrintRows(item);
          const totalKoli = detailRows.reduce((acc, detailItem) => acc + detailItem.koli, 0);
          const totalIkat = detailRows.reduce((acc, detailItem) => acc + detailItem.ikat, 0);

          return (
          <div className="container print-one mb-5" key={index}>
            <div>
              <div className="d-flex">
                <Row style={{ width: "100%" }}>
                  <Col>
                    <img
                      className="justify-content-start"
                      src="https://elogs.eurekalogistics.co.id/assets/admin/dist/img/logo-race.png"
                      alt=""
                      style={{ maxWidth: "50%", maxHeight: "50%" }} // Ensure the image fits well
                    />
                  </Col>
                  <Col>
                    <div className="text-center justify-content-center">
                      <h2 style={{ fontSize: 16 }}>
                        <b>PRINT RETUR ORDER</b>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-end justify-content-end">
                      <svg id={`barcode${index}`}></svg>
                    </div>
                  </Col>
                </Row>
              </div>
              <AntRow className="mt-3">
                <AntCol
                  xs={24}
                  sm={12}
                  md={10}
                  style={{ fontSize: 13, fontWeight: "bold" }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td className="nowrap">Nomor Retur</td>
                        <td className="mx-2">:</td>
                        <td>{item.sp || item.so || item.sm || "-"}</td>
                      </tr>
                      <tr>
                        <td className="nowrap">No Referensi</td>
                        <td className="mx-2">:</td>
                        <td>{item.noReferensi && item.noReferensi !== "-" ? item.noReferensi : "-"}</td>
                      </tr>
                      <tr>
                        <td className="nowrap">Tanggal</td>
                        <td className="mx-2">:</td>
                        <td>{item.tgl_pickup || item.pickupDate || item.tglPickup || item.tglSp || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </AntCol>

                <AntCol
                  xs={24}
                  sm={12}
                  md={12}
                  style={{ fontSize: 13, fontWeight: "bold" }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td>Nama Driver</td>
                        <td className="mx-2">:</td>
                        <td>{item.driver || item.detail?.[0]?.driver || "-"}</td>
                      </tr>
                      <tr>
                        <td>Plat Nomor</td>
                        <td className="mx-2">:</td>
                        <td>{item.nopol || item.detail?.[0]?.noPol || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </AntCol>
              </AntRow>

              <AntRow className="mt-1" style={{ fontSize: 13, fontWeight: "bold" }}>
                <AntCol xs={24} sm={24} md={16}>
                  <table>
                    <tbody>
                      <tr>
                        <td className="nowrap">Alamat</td>
                        <td className="mx-2">:</td>
                        <td>{getPrintAddress(item)}</td>
                      </tr>
                    </tbody>
                  </table>
                </AntCol>
              </AntRow>
            </div>
            <table
              style={{ fontSize: 12, border: "2px solid black" }}
              className="table table-bordered mt-3"
            >
              <thead className="text-center">
                <tr>
                  <th rowSpan="2" className="align-middle" style={{ width: "5%" }}>
                    NO
                  </th>
                  <th rowSpan="2" className="align-middle" style={{ width: "35%" }}>
                    NAMA PELANGGAN
                  </th>
                  <th rowSpan="2" className="align-middle" style={{ width: "35%" }}>
                    MEMO
                  </th>
                  <th colSpan="2">JUMLAH</th>
                </tr>
                <tr>
                  <th>COLLY</th>
                  <th>IKAT</th>
                </tr>
              </thead>
              <tbody>
                {detailRows.map((detailItem, detailIndex) => (
                  <tr className="text-center" key={detailIndex}>
                    <td>{detailIndex + 1}</td>
                    <td>{detailItem.sekolahTujuan}</td>
                    <td>{detailItem.memoText}</td>
                    <td>{detailItem.koli}</td>
                    <td>{detailItem.ikat}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="3" style={{ fontWeight: "bold", fontSize: "16px" }}>
                    TOTAL
                  </td>
                  <td className="text-center">
                    {totalKoli}
                  </td>
                  <td className="text-center">
                    {totalIkat}
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ fontSize: 16 }}>
              <b>Note :</b>
            </div>
            <div
              style={{ border: "2px solid black", padding: 10, textAlign: "start" }}
            >
              <p>
                <b>
                  <i style={{ fontSize: 16, fontWeight: "bold" }}>
                    Penarikan retur dilakukan hanya untuk barang yang telah terbungkus (ikat/koli), tersegel, berlabel, dan sesuai dengan jumlah yang tercantum pada dokumen retur. Raja Cepat tidak bertanggung jawab atas isi, kelengkapan, maupun kondisi barang setelah diterima oleh gudang penerima.
                  </i>
                </b>
              </p>
            </div>

            <div className="row text-center mt-3">
              <AntRow>
                <AntCol span={8} style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Pelanggan</p>
                  <p style={{ marginTop: 80 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, Tanggal, dan Stempel</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </AntCol>
                <AntCol span={8} style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Driver</p>
                  <p style={{ marginTop: 80 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, dan Tanggal</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </AntCol>
                <AntCol span={8} style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Penerima</p>
                  <p style={{ marginTop: 80 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, dan Tanggal</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </AntCol>
              </AntRow>
            </div>
          </div>
          );
        })
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default PrintRO1Halaman;
